import { render, staticRenderFns } from "./WaitingCriticalResourceContainer.vue?vue&type=template&id=6896d1e0&scoped=true&"
import script from "./WaitingCriticalResourceContainer.vue?vue&type=script&lang=js&"
export * from "./WaitingCriticalResourceContainer.vue?vue&type=script&lang=js&"
import style0 from "./WaitingCriticalResourceContainer.vue?vue&type=style&index=0&id=6896d1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896d1e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VContainer,VSpacer})
